import { render, staticRenderFns } from "./CreateOld.vue?vue&type=template&id=4a319f8a&"
import script from "./CreateOld.vue?vue&type=script&lang=js&"
export * from "./CreateOld.vue?vue&type=script&lang=js&"
import style0 from "./CreateOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports